import { useNavigate } from 'react-router-dom';
import useInView from '../../../hooks/useInView';

const CareersSection = () => {
  const navigate = useNavigate();
  const { ref: leftRef, inView: leftInView } = useInView();
  const { ref: rightRef, inView: rightInView } = useInView();

  const roles = [
    { title: 'HVAC Technician', type: 'Full Time', locations: 'Tampa Bay, FL' },
    { title: 'Plumbing Technician', type: 'Full Time', locations: 'Orlando, FL' },
    { title: 'Electrician', type: 'Full Time', locations: 'South Florida' },
    { title: 'Home Comfort Advisor', type: 'Full Time / Commission', locations: 'Statewide Florida' },
    { title: 'Install Team Lead', type: 'Full Time', locations: 'Statewide Florida' },
    { title: 'Customer Experience', type: 'Full Time', locations: 'Remote Available' },
  ];

  return (
    <section id="careers" className="py-10 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div
            ref={leftRef}
            className={`transition-all duration-800 ease-out ${leftInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}
          >
            <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Join Our Team</p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#111827] mb-5 sm:mb-6">
              Build Your Career with Renova
            </h2>
            <p className="text-base sm:text-lg text-[#6B7280] mb-6 sm:mb-8 leading-relaxed">
              Renova is growing fast and hiring across Florida. We offer competitive pay, benefits, ongoing training, and a clear path to advancement, from technician to team lead.
            </p>
            <div className="space-y-4 mb-8">
              {[
                { icon: 'ri-money-dollar-circle-line', text: 'Competitive pay + performance bonuses' },
                { icon: 'ri-heart-pulse-line', text: 'Full benefits: health, dental, vision' },
                { icon: 'ri-car-line', text: 'Company vehicle and tools provided' },
                { icon: 'ri-graduation-cap-line', text: 'Paid training and certifications' },
                { icon: 'ri-arrow-up-line', text: 'Clear advancement and growth paths' },
              ].map((b, i) => (
                <div
                  key={b.text}
                  style={{ transitionDelay: `${100 + i * 70}ms` }}
                  className={`flex items-center space-x-3 transition-all duration-600 ease-out ${leftInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-6'}`}
                >
                  <div className="w-8 h-8 bg-[#C41E3A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${b.icon} text-base text-[#C41E3A]`} />
                  </div>
                  <span className="text-sm text-[#374151]">{b.text}</span>
                </div>
              ))}
            </div>
            <button
              onClick={() => navigate('/careers')}
              className="bg-[#C41E3A] text-white px-7 py-3.5 rounded-lg text-sm font-semibold hover:bg-[#A01830] transition-colors whitespace-nowrap cursor-pointer"
            >
              View All Open Positions
            </button>
          </div>

          <div ref={rightRef}>
            <div className="space-y-3">
              {roles.map((r, i) => (
                <button
                  key={r.title}
                  onClick={() => navigate('/careers')}
                  style={{ transitionDelay: `${i * 80}ms` }}
                  className={`w-full flex items-center justify-between p-5 bg-[#F8F9FB] hover:bg-[#FEF2F2] border border-[#E2E8F0] hover:border-[#C41E3A]/30 rounded-xl transition-all duration-600 ease-out group cursor-pointer text-left ${rightInView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}
                >
                  <div>
                    <p className="text-sm font-bold text-[#111827] group-hover:text-[#C41E3A] transition-colors">{r.title}</p>
                    <p className="text-xs text-[#6B7280] mt-0.5">{r.type} · {r.locations}</p>
                  </div>
                  <i className="ri-arrow-right-line text-[#9CA3AF] group-hover:text-[#C41E3A] transition-colors" />
                </button>
              ))}
            </div>
            <div
              style={{ transitionDelay: '500ms' }}
              className={`mt-6 bg-gradient-to-r from-[#0C2340] to-[#1A56A0] rounded-xl p-6 text-center transition-all duration-700 ease-out ${rightInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            >
              <p className="text-white font-bold mb-2">Don&apos;t See Your Role?</p>
              <p className="text-white/60 text-sm mb-4">Send us your resume. We&apos;re always looking for great talent.</p>
              <button
                onClick={() => navigate('/careers')}
                className="bg-white text-[#1A56A0] px-5 py-2 rounded-lg text-sm font-semibold hover:bg-[#EEF5FF] transition-colors whitespace-nowrap cursor-pointer"
              >
                Send Open Application
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersSection;
